import { NisModal } from "../lib/ui/NisModal";
import Properties from "../cluetrainer/ui/widgets/Properties";
import LightButton from "../cluetrainer/ui/widgets/LightButton";
import { SliderBenchmarkModal } from "./SliderBenchmarking";
import { PDBGeneratorModal, RegionIndexingModal } from "./sliderdb/RegionEditor";
import { clue_trainer_test_set } from "../tests/tests";
import { PDBManager } from "../cluetrainer/cluesolving/subbehaviours/SliderSolving";
import { makeshift_main } from "../cluetrainer/main";
import { ImportModal } from "../cluetrainer/ui/widgets/modals/ImportModal";
import { LogViewer } from "./LogViewer";
import { Log } from "../lib/util/Log";
import { deps } from "../cluetrainer/dependencies";
import { SliderShuffleAnalysis } from "./SliderShuffleAnalysis";
import { Notification } from "../cluetrainer/ui/NotificationBar";
import { ClueReader } from "../cluetrainer/cluesolving/cluereader/ClueReader";
import ExportStringModal from "../cluetrainer/ui/widgets/modals/ExportStringModal";
import { export_method_csv } from "./MethodCSVExport";
import { MethodPackManager } from "../cluetrainer/MethodPackManager";
import { CapturedImage } from "../lib/alt1/capture";
import { CompassCalibrationTool } from "./CompassCalibrationTool";
import { util } from "../lib/util/util";
import { SlideReader } from "../cluetrainer/cluesolving/cluereader/SliderReader";
import { FontSheets } from "./FontSheets";
import { ImageDetect } from "alt1";
import { ChatboxFinder } from "../lib/alt1/readers/chatreader/ChatboxFinder";
import { ChatReader } from "../lib/alt1/readers/ChatReader";
import { MessageBuffer } from "../lib/alt1/readers/chatreader/ChatBuffer";
import { MinimapReader } from "../lib/alt1/readers/MinimapReader";
import teleport_data from "../data/teleport_data";
import { LuaUtils } from "./lua_utils";
import { clue_data } from "../data/clues";
var notification = Notification.notification;
var cleanedJSON = util.cleanedJSON;
var FontScript = FontSheets.FontScript;
var log = Log.log;
var CapturedMinimap = MinimapReader.CapturedMinimap;
export class DevelopmentModal extends NisModal {
    constructor() {
        super();
        this.setTitle("Super Secret Development Menu");
    }
    render() {
        super.render();
        const layout = new Properties().appendTo(this.body);
        layout.paragraph("Welcome to the super secret development menu! If you're not a developer, you probably won't find anything useful here, but feel free to take a look around. Important note: Some options may mess up your local data/settings without warning you about it before doing so!");
        layout.header("General");
        layout.row(new LightButton("Log Viewer")
            .onClick(() => {
            ImportModal.json(txt => txt, buffer => { new LogViewer(buffer).show(); });
        }));
        layout.header("Slider Puzzles");
        layout.row(new LightButton("Benchmark Solvers")
            .onClick(() => {
            new SliderBenchmarkModal().show();
        }));
        layout.row(new LightButton("Generate PDB")
            .onClick(() => {
            new PDBGeneratorModal().show();
        }));
        layout.row(new LightButton("Benchmark Region Indexing")
            .onClick(() => {
            new RegionIndexingModal().show();
        }));
        layout.row(new LightButton("Delete local pdbs")
            .onClick(() => {
            PDBManager.instance.get().clearCache();
        }));
        layout.row(new LightButton("Analyze sliders")
            .onClick(() => {
            ImportModal.json(p => p, data => {
                new SliderShuffleAnalysis(data).show();
            });
        }));
        layout.row(new LightButton("Create compressed slider references")
            .onClick(async () => {
            const sliders = await Promise.all(SlideReader.reference_slider_themes.map(SlideReader.downloadReferenceSliderFromTheme));
            const encoded = SlideReader.SimplifiedReferenceSliderMap.encode(sliders);
            const decoded = Object.values(SlideReader.SimplifiedReferenceSliderMap.decode(encoded));
            ExportStringModal.do(cleanedJSON(encoded), "Slider references", "slider_references.json");
        }));
        layout.header("Compass");
        layout.row(new LightButton("Calibration Tool")
            .onClick(() => {
            new CompassCalibrationTool().show();
        }));
        layout.header("Readers");
        layout.row(new LightButton("Test Screenshot")
            .onClick(async () => {
            const reader = new ClueReader(false);
            await reader.initialization.wait();
            const chat_finder = await ChatboxFinder.instance.get();
            const chat_icons = await ChatReader.ChatIcons.instance.get();
            ImportModal.img(async (img) => {
                const bound = CapturedImage.bind(img);
                log().log("Detected Clue:");
                log().log(reader.read(bound));
                const chatboxes = chat_finder.find(bound);
                log().log(`${chatboxes.length} detected chatboxes:`);
                chatboxes.forEach(chatbox => {
                    log().log("Detected Chatbox", "", chatbox.body.getData());
                    const reader = new ChatReader.SingleChatboxReader(chat_icons, chatbox);
                    reader.read();
                    log().log("Messages:");
                    reader.buffer.get().forEach(message => {
                        log().log(MessageBuffer.Message.toString(message));
                    });
                });
                const minimap_finder = await CapturedMinimap.finder.get();
                const minimap = minimap_finder.find(bound);
                log().log(minimap ? "Minimap found:" : "No Minimap found");
                if (minimap) {
                    log().log(minimap.body.screenRectangle());
                }
            });
        }));
        layout.header("Tests");
        layout.row(new LightButton("Run Tests")
            .onClick(() => {
            clue_trainer_test_set.run();
        }));
        layout.row(new LightButton("Run makeshift Main")
            .onClick(async () => {
            await makeshift_main();
            notification("Finished running makeshift main").show();
        }));
        layout.header("Other");
        layout.row(new LightButton("Open Development Utility Layer")
            .onClick(() => {
            deps().app.menu_bar.switchToTab("utility");
        }));
        layout.row(new LightButton("Export Method Times as CSV")
            .onClick(async () => {
            ExportStringModal.do(await export_method_csv(MethodPackManager.instance()), "", "method_times.csv");
        }));
        layout.row(new LightButton("Font Creator")
            .onClick(async () => {
            const sheet = await ImageDetect.imageDataFromUrl("/alt1anchors/fonts/modal_text_font.png");
            await (new class extends NisModal {
                constructor() { super({ size: "fullscreen" }); }
                render() {
                    super.render();
                    this.title.set("Font Sheet Creator");
                    /*  Default fontscript:
                        all_cahrs.forEach(align_bot("O"))
                        getchars("gpqy").forEach(align_top("o"))
                        getchars("j").forEach(align_top("i"))
                        range("A", "Z").forEach(align_top("O"))
                        range("0", "9").forEach(align_top("O"))
                        align_top(":")(";")
                        align_top(".")(",")
                        align_bot(";")(",")
                        getchars("(){}[]+-<=>@#|/\\~").forEach(center("O"))
        
                     */
                    new FontSheets.FontSheetEditor({
                        image: sheet,
                        font_script: FontScript.parse("alignbot . O\n" +
                            "aligntop [gpgy] o\n" +
                            "aligntop j i\n" +
                            "aligntop [A-Z] O\n" +
                            "aligntop [0-9] O\n" +
                            "aligntop : ;\n" +
                            "aligntop \\. ,\n" +
                            "alignbot ; ,\n" +
                            "center [(){}[\\]+-\\<\\=\\>@#|/\\\\~\"] O\n" +
                            "pad [T] 0 1\n" +
                            "pad [rvxsmk] 0 -1\n" +
                            "pad [tz] -1 0\n" +
                            "pad [p] 1 0\n" +
                            "pad [SHE] 1 0\n" +
                            "pad [N] 1 2\n" +
                            "pad [Z] 0 1\n" +
                            "pad [S] 1 0\n" +
                            "normalize").script,
                    }).appendTo(this.body);
                }
            }).show();
        }));
        layout.header("Lua");
        layout.row(new LightButton("Get Lua Teleports")
            .onClick(() => {
            ExportStringModal.do(LuaUtils.asTypedFile(teleport_data, "teleports", "TeleportGroup[]"), null, "teleports.lua");
        }));
        layout.row(new LightButton("Get Lua Clues")
            .onClick(() => {
            ExportStringModal.do(LuaUtils.asTypedFile(clue_data.all, "clues", "Step[]"), null, "clues.lua");
        }));
    }
}
